import { useMutation } from '@tanstack/react-query'

import { createTrackingEvent } from './api'

export const useCreateTrackingEvent = () =>
  useMutation({
    mutationFn: createTrackingEvent,
  })
